/**
 * @generated SignedSource<<aacb0fac5a7a9124f7b6d1b49eaa5272>>
 * @relayHash 462f52dcf04a704f3f189d003436f376
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0

import type { ConcreteRequest } from 'relay-runtime';
export type useContentOwnershipSpaceAdminsSpaceAdminsListQuery$variables = {
  spaceKey: string;
};
export type useContentOwnershipSpaceAdminsSpaceAdminsListQuery$data = {
  readonly space: {
    readonly admins: ReadonlyArray<{
      readonly email?: string | null;
      readonly type: string | null;
    } | null>;
    readonly id: string | null;
  } | null;
};
export type useContentOwnershipSpaceAdminsSpaceAdminsListQuery = {
  response: useContentOwnershipSpaceAdminsSpaceAdminsListQuery$data;
  variables: useContentOwnershipSpaceAdminsSpaceAdminsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "accountType",
    "value": "ATLASSIAN"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "email"
    }
  ],
  "type": "KnownUser"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "admins",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": "admins(accountType:\"ATLASSIAN\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "admins",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": "admins(accountType:\"ATLASSIAN\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "462f52dcf04a704f3f189d003436f376",
    "id": "7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0",
    "metadata": {},
    "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
    "operationKind": "query",
    "text": "query useContentOwnershipSpaceAdminsSpaceAdminsListQuery($spaceKey:String!){space(key:$spaceKey){id,admins(accountType:ATLASSIAN){__typename,type,...on KnownUser{email}}}}"
  }
};
})();

(node as any).hash = "e7540581691bddbb5911e7d86948b5a5";

export default node;
